import { UnauthenticatedError } from "@sp-crm/core";
import { ClientHttpError, ClientTrpcNetworkError } from "util/http";
import { checkVersionHeader } from "util/version-check";

export type TrpcFetch = (
    url: URL | RequestInfo,
    options: RequestInit | undefined,
) => Promise<Response>;

export const makeTrpcFetch =
    (fetchImpl: TrpcFetch): TrpcFetch =>
    async (
        url: URL | RequestInfo,
        options: RequestInit | undefined,
    ): Promise<Response> => {
        let res: Response;
        try {
            res = await fetchImpl(url, {
                ...options,
                credentials: "include",
            });
        } catch (e) {
            throw new ClientTrpcNetworkError(
                e instanceof Error ? e : new Error(String(e)),
            );
        }

        const contentType = res.headers.get("content-type") || "";
        const isJsonResponse = contentType.includes("application/json");

        checkVersionHeader(res.headers);

        if (res.status === 401) {
            throw new UnauthenticatedError();
        }

        if (!isJsonResponse) {
            const responseBody = await res.text();
            throw new ClientHttpError(
                "trpc",
                res.status,
                res.statusText,
                responseBody.slice(0, 500),
                "tRPC",
            );
        }

        return res;
    };
